import { useMemo } from 'react';
import { Card, CircularLoader, Column, FullRow, Row, Typography } from 'seagull';
import { DollarCircle } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useBillingSchedule } from "../../../../../hooks/reactQuery/queries/useBillingSchedule";
import { utils } from "../../../../../utils";
import styles from "./BillingSchedule.module.scss";
import { translateBillingSchedule } from "./BillingSchedule.utils";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const GetBillingScheduleTID = () => getTestIds();
export const BillingSchedule = _ref => {
  let {
    relationshipId,
    isPreview,
    source = 'relationship',
    selectedOptionalServices,
    selectedBundleId
  } = _ref;
  const {
    BillingScheduleTestIds
  } = useMemo(() => GetBillingScheduleTID(), []);
  const {
    billingSchedule,
    isLoading
  } = useBillingSchedule(relationshipId, source, isPreview || source === 'draft', {
    selectedOptionalServices,
    selectedBundleId
  });
  const {
    sections
  } = useMemo(() => translateBillingSchedule(billingSchedule !== null && billingSchedule !== void 0 ? billingSchedule : {
    groups: []
  }), [billingSchedule]);
  if (isLoading) {
    return /*#__PURE__*/_jsxs(Column, {
      gap: 8,
      "data-testid": BillingScheduleTestIds.Root(),
      children: [/*#__PURE__*/_jsxs(FullRow, {
        gap: 12,
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(DollarCircle, {}), /*#__PURE__*/_jsxs(Column, {
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "h6",
            weight: "normal",
            "data-testid": BillingScheduleTestIds.Title(),
            children: "Billing Schedule"
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph1",
            weight: "light",
            skin: "secondary",
            "data-testid": BillingScheduleTestIds.Subtitle(),
            children: "For automatically billed services"
          })]
        })]
      }), /*#__PURE__*/_jsx(CircularLoader, {
        "data-testid": BillingScheduleTestIds.Loader()
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Column, {
    gap: 8,
    "data-testid": BillingScheduleTestIds.Root(),
    children: [/*#__PURE__*/_jsxs(FullRow, {
      gap: 12,
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(DollarCircle, {}), /*#__PURE__*/_jsxs(Column, {
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h6",
          weight: "normal",
          "data-testid": BillingScheduleTestIds.Title(),
          children: "Billing Schedule"
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph1",
          weight: "light",
          skin: "secondary",
          "data-testid": BillingScheduleTestIds.Subtitle(),
          children: "For automatically billed services"
        })]
      })]
    }), sections.length > 0 && /*#__PURE__*/_jsx(Card, {
      className: styles.billingScheduleCard,
      "data-testid": BillingScheduleTestIds.Card(),
      children: /*#__PURE__*/_jsx(Column, {
        gap: 24,
        children: sections.map((section, sectionIndex) => {
          const isPaused = section.title.includes('upon activation');
          return /*#__PURE__*/_jsxs(Column, {
            gap: 12,
            "data-testid": BillingScheduleTestIds.Section(sectionIndex),
            children: [/*#__PURE__*/_jsxs(Typography, {
              variant: "paragraph1",
              weight: "normal",
              "data-testid": BillingScheduleTestIds.SectionTitle(sectionIndex),
              children: [section.title, !isPaused && " - ".concat(utils.formatDollarAmount(section.totalAmount))]
            }), /*#__PURE__*/_jsx("ul", {
              className: styles.servicesList,
              children: section.services.map((service, serviceIndex) => {
                return /*#__PURE__*/_jsxs("li", {
                  className: styles.serviceItem,
                  "data-testid": BillingScheduleTestIds.ServiceItem(sectionIndex, serviceIndex),
                  children: [/*#__PURE__*/_jsx("div", {
                    className: styles.bullet
                  }), /*#__PURE__*/_jsxs(Column, {
                    gap: 2,
                    children: [/*#__PURE__*/_jsx(Typography, {
                      variant: "paragraph1",
                      "data-testid": BillingScheduleTestIds.ServiceName(sectionIndex, serviceIndex),
                      children: service.name
                    }), /*#__PURE__*/_jsx(Column, {
                      gap: 2,
                      children: /*#__PURE__*/_jsxs(Row, {
                        gap: 4,
                        alignItems: "center",
                        children: [/*#__PURE__*/_jsx(Typography, {
                          variant: "paragraph2",
                          skin: "secondary",
                          "data-testid": BillingScheduleTestIds.ServicePrice(sectionIndex, serviceIndex),
                          children: utils.formatDollarAmount(service.price)
                        }), service.notes.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
                          children: [/*#__PURE__*/_jsx(Typography, {
                            variant: "paragraph2",
                            skin: "secondary",
                            children: "\u2022"
                          }), /*#__PURE__*/_jsx(Typography, {
                            variant: "paragraph2",
                            skin: "secondary",
                            "data-testid": BillingScheduleTestIds.ServiceNotes(sectionIndex, serviceIndex),
                            children: service.notes.join(', ')
                          })]
                        })]
                      })
                    })]
                  })]
                }, "".concat(service.serviceId, "-").concat(serviceIndex));
              })
            })]
          }, sectionIndex);
        })
      })
    })]
  });
};